import {addEmbeddedDashboardTab} from 'insights/embeddings/backbone/InitializeBioentityEmbeddedDashboardTab';
import {BufferStates, TabState} from 'Navigation';

export default function initializeCoreBioentityWorkspaceTabs(
  buffers: BufferStates,
  metadataTab: TabState | null,
  noteTab: TabState,
  resultsTab: TabState | null,
  storageTab: TabState | null,
  childEntityTabs: Array<TabState> | null,
  embeddedDashboardTab: TabState | null,
  relevantItemsTab: TabState | null,
  testOrdersTab: TabState | null
): void {
  if (metadataTab != null) {
    buffers.at(0).add(metadataTab);
  }
  if (relevantItemsTab != null) {
    buffers.at(1).add(relevantItemsTab);
  }
  buffers.at(1).add(noteTab);
  if (resultsTab != null) {
    buffers.at(1).add(resultsTab);
  }
  if (storageTab != null) {
    buffers.at(1).add(storageTab);
  }
  if (childEntityTabs != null) {
    for (const childEntityTab of childEntityTabs) {
      buffers.at(1).add(childEntityTab);
    }
  }
  if (testOrdersTab != null) {
    buffers.at(1).add(testOrdersTab);
  }
  addEmbeddedDashboardTab(buffers, embeddedDashboardTab);

  // First, add all tabs above. Then, set some of them to be active here.
  //
  // Make sure to do those steps in that order so that `BufferState:add` appends tabs. (If it sees an active
  // tab, then `add` will instead insert the tab to the right of the active tab.)
  if (metadataTab != null) {
    metadataTab.set({active: true});
  }
  noteTab.set({active: true});
}
